import React from 'react';

const Footer = () => (
  <footer className="app__footer">
  </footer>
);

export default Footer;
